import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_KILL } from "./gql";

const useKillRun = createDefaultMutationHook(RUN_KILL);

export default useKillRun;